import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import EditableTable from '../../../../primer/Editable-Table';
import {Accordion, Badge, Col, Modal, Spinner} from 'react-bootstrap';
import {
    getDifficultyOptions, getInstallationsTypes,
    getStockholderPositions, isEmpty,
    resetTableItemsId
} from '../../../../../_helpers/commonFunctions';
import {setSaveEditClient} from "../../../../../_reducers/activitySlice";
import {
    setClientEmronStockholders,
    setEditClient,
    setSelectedEmronPaymentsFilters,
    resetEditClientEmronStockholder,
} from '../../../../../_reducers/DataPanel/Clients/clientSlice';
import {
    deleteObjectFromArrayOfObjects,
    getLabelByValue
} from "../../../../../_helpers/helperFunctions";
import AccountingBox from "../../../../primer/AccountingBox";
import Button from "react-bootstrap/Button";
import {toast} from "react-toastify";
import axios from "axios";
import {openTabByType} from "../../../../../_helpers/tabOpeners";
import useTaggedDispatch from "../../../../../hooks/useTaggedDispatch";
import {FaDownload, FaEye} from "react-icons/fa";
import {formatPath, getFileNameFromPath, getMimeType, popExtension} from "../../Cloud/Components/constants";
import {useTranslation} from "../../../../../hooks/useTranslation";

const EditClientEmron = ({tabKey}) => {
    const {t} = useTranslation();
    const dispatch = useTaggedDispatch({tabKey});
    const editClient = useSelector((state) => state.CLIENTS_DATA.editClient[tabKey]);
    const company = useSelector(state => state.COMPANY_DATA.company);
    const CLIENTS_DATA = useSelector((state) => state.CLIENTS_DATA);
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const [productListData, setProductListData] = useState([]);

    const [updatingGEMH, setUpdatingGEMH] = useState(false);
    const [showFetchFromGEMH, setShowFetchFromGEMH] = useState(false);

    let clientInstallationListData = editClient?.installations?.slice();
    if (clientInstallationListData?.length > 0) {
        clientInstallationListData = clientInstallationListData.map(installation => {
            const modifiedInstallation = {...installation}; // Create a new object with the same properties
            modifiedInstallation.type = getLabelByValue(getInstallationsTypes(), installation.type, 'value');
            modifiedInstallation.address = modifiedInstallation?.address + ", " + modifiedInstallation?.city + ", " + modifiedInstallation?.postalCode;
            return modifiedInstallation;
        });
    }

    useEffect(() => {
        onProductSearch(null, null, setProductListData);
    }, [])

    const onProductSearch = (cellName, keyword, setData) => {
        let reqData = {
            company: company.id,
        }
        if (keyword) reqData.keyword = keyword;
        axios.get(`${process.env.REACT_APP_API_URL2}/category/get-product-list`, {
            headers: {'Content-Type': 'application/json'},
            params: reqData
        }).then((res) => {
            if (res.data.status === "200") {
                setData(res.data.data);
            } else {
                setData([]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const clientContactPointsColumns = [
        {
            name: "No",
            field: "no",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.contactName'),
            field: "name",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.mobilePhone'),
            field: "mobile",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.landLine'),
            field: "landline",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.otherPhone'),
            field: "otherPhone",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.email'),
            field: "email",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.contactNotes'),
            field: "contactNotes",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsGeneralEdit.table.acceptNotifications'),
            field: "acceptsNotifications",
            editable: true,
            inputType: {
                type: "checkbox",
            },
        },
    ]

    const passwordsColumns = [
        {
            name: "No",
            field: "no",
            editable: false,
        },
        {
            name: t('ClientsNewEmronEdit.table1.type'),
            field: "type",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsNewEmronEdit.table1.username'),
            field: "username",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsNewEmronEdit.table1.password'),
            field: "password",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsNewEmronEdit.table1.notes'),
            field: "notes",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
    ]
    const stackholdersColumns = [
        {
            name: "No",
            field: "no",
            editable: false,
        },
        {
            name: t('ClientsNewEmronEdit.table2.name'),
            field: "name",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsNewEmronEdit.table2.surname'),
            field: "surname",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsNewEmronEdit.table2.vat'),
            field: "vat",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ClientsNewEmronEdit.table2.position'),
            field: "position",
            width: '120px',
            editable: true,
            inputType: {
                options: getStockholderPositions(),
                type: 'dropdown',
            }
        },
        {
            name: t('ClientsNewEmronEdit.table2.percentage'),
            field: "percentage",
            editable: true,
            inputType: {
                type: 'accounting',
            }
        },
        {
            name: t('ClientsNewEmronEdit.table2.stockValue'),
            field: "stockValue",
            editable: true,
            disabled: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7,
                }
            }
        },
        {
            name: t('ClientsNewEmronEdit.table2.dateFrom'),
            field: "dateFrom",
            editable: true,
            inputType: {
                type: 'datebox',
                allowOtherYears: "true"
            }
        },
        {
            name: t('ClientsNewEmronEdit.table2.dateTo'),
            field: "dateTo",
            editable: true,
            inputType: {
                type: 'datebox',
                allowOtherYears: "true"
            }
        },
    ];
    const clientInstallationsDropdownColumns = [
        {
            label: t('SalesNew.installationTable.type'),
            name: "type",
        },
        {
            label: t('SalesNew.installationTable.address'),
            name: "address",
        }
    ];
    const productCodeColumns = [
        {
            label: t('SalesNewView.productCodeTable.code'),
            name: "code",
        },
        {
            label: t('SalesNewView.productCodeTable.productName'),
            name: "name",
        },
        {
            label: t('SalesNewView.productCodeTable.alternativeName'),
            name: "alternateName",
        },
    ];

    const getBankAccountsLimitOptions = (limit = 20) => {
        const arr = [];
        for (let i = 0; i <= limit; i++) {
            arr.push({
                value: i,
                label: i,
            })
        }
        return arr;
    }

    const emronPaymentsColumns = [
        {
            name: "No",
            field: "no",
            width: "2%",
            editable: false,
        },
        {
            name: "Εγκατάσταση",
            width: "15%",
            field: "installation",
            editable: true,
            inputType: {
                config: {
                    excludeColumns: [],
                    columns: clientInstallationsDropdownColumns,
                    data: clientInstallationListData,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: t("Placeholders.selectInstallation")
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: "Μήνας Από",
            field: "month",
            width: "8%",
            editable: true,
            inputType: {
                type: 'monthDatebox',
            }
        },
        {
            name: "Μήνας Μέχρι",
            field: "monthTo",
            width: "8%",
            editable: true,
            inputType: {
                type: 'monthDatebox',
            }
        },
        {
            name: "Καθαρή Αξία",
            field: "amount",
            width: "8%",
            editable: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7,
                }
            }
        },
        {
            name: "Σημειώσεις",
            field: "notes",
            width: '10%',
            editable: true,
            inputType: {
                type: 'textarea'
            }
        },
        {
            name: "Δυσκολία",
            field: "difficulty",
            width: "9%",
            editable: true,
            inputType: {
                options: getDifficultyOptions(),
                type: 'dropdown',
            }
        },
        {
            name: "Σημειώσεις Δυσκολίας",
            field: "difficultyNotes",
            width: "10%",
            editable: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Αποδοχή πληρωμών μέσω κάρτας",
            field: "acceptCardPayments",
            width: "5%",
            editable: true,
            inputType: {
                type: "checkbox"
            }
        },
        {
            name: "Είδος",
            field: "productName",
            width: "20%",
            editable: true,
            inputType: {
                config: {
                    excludeColumns: [],
                    columns: productCodeColumns,
                    data: productListData,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Επιλέξτε είδος",
                    onChangeSearchCell: onProductSearch,
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: "Πλήθος Τραπ. Λογ.",
            field: "bankAccountsLimit",
            width: "5%",
            editable: true,
            inputType: {
                options: getBankAccountsLimitOptions(),
                type: 'dropdown',
            }
        }
    ];
    const handleOnChange = (e) => {
        // Set if editing the form
        if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));

        let value = e.target.value;
        dispatch(setEditClient({...editClient, capital: value}));
    }
    const handlePasswordsChanges = {
        insert: (e, data) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));

            let tempEmronPassword = Object.assign({}, CLIENTS_DATA.editClientEmronPassword);
            tempEmronPassword[data.field] = data.value;
            if (tempEmronPassword && (tempEmronPassword.type || tempEmronPassword.username || tempEmronPassword.password || tempEmronPassword.notes)) {
                let updatedEmronPasswords = Object.assign({}, tempEmronPassword);
                let oldEmronPasswords = editClient.emronPasswords;
                updatedEmronPasswords.no = oldEmronPasswords.length + 1;
                updatedEmronPasswords.id = oldEmronPasswords.length + 1;

                dispatch(setEditClient({
                    ...editClient,
                    emronPasswords: [...oldEmronPasswords, updatedEmronPasswords]
                }));
            }
        },
        update: async (data, id) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));

            let emronPasswords = editClient.emronPasswords.slice();
            await Promise.all(emronPasswords.map((password, index) => {
                if (password.id === id) {
                    emronPasswords[index] = {...password, ...data};
                }
                return password;
            }))
            dispatch(setEditClient({...editClient, emronPasswords: emronPasswords}));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));

            let emronPasswords = editClient.emronPasswords.slice();
            emronPasswords.splice(rowIndex, 1);
            emronPasswords = resetTableItemsId(emronPasswords);
            dispatch(setEditClient({...editClient, emronPasswords: emronPasswords}));
        }
    }

    const handleStockholdersChanges = {
        insert: (e, data) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));

            if (data.field === "percentage" && Number(data.value) > 100) {
                toast.error("Percentage must be below 100");
            } else {
                let tempEmronStockholder = Object.assign({}, CLIENTS_DATA.editClientEmronStockholder);
                tempEmronStockholder[data.field] = data.value;
                if (tempEmronStockholder && (
                    tempEmronStockholder.name !== '' ||
                    tempEmronStockholder.surname !== '' ||
                    tempEmronStockholder.vat !== '' ||
                    tempEmronStockholder.position !== '' ||
                    tempEmronStockholder.percentage !== '' || tempEmronStockholder.stockValue !== '' || tempEmronStockholder.dateFrom !== '' || tempEmronStockholder.dateTo !== '')) {
                    let updatedEmronStockholders = Object.assign({}, tempEmronStockholder);
                    let oldEmronStockholders = editClient.stockholders;
                    updatedEmronStockholders.no = oldEmronStockholders.length + 1;
                    updatedEmronStockholders.id = oldEmronStockholders.length + 1;
                    if (data.field === "percentage") {
                        updatedEmronStockholders.stockValue = editClient.capital * Number(data?.value) / 100;
                    }
                    dispatch(resetEditClientEmronStockholder());
                    dispatch(setEditClient({
                        ...editClient,
                        stockholders: [...oldEmronStockholders, updatedEmronStockholders]
                    }));
                }
            }
        },
        update: (data, id) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));

            if (data?.percentage && Number(data.percentage) > 100) {
                toast.error("Percentage must be below 100");
            } else {
                let emronStockholders = editClient.stockholders.slice();
                if (emronStockholders.find(item => item.id === id) !== undefined) {
                    emronStockholders[id - 1] = {...emronStockholders[id - 1], ...data};
                    if (data?.percentage) {
                        emronStockholders[id - 1].stockValue = editClient.capital * Number(data?.percentage) / 100;
                    }
                    dispatch(setClientEmronStockholders(emronStockholders)); // update data
                    dispatch(setEditClient({...editClient, stockholders: emronStockholders}))
                }
            }
        },
        selected: () => {},
        delete: (id) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));

            let emronStockholders = editClient.stockholders.slice();
            if (id) {
                emronStockholders = deleteObjectFromArrayOfObjects(emronStockholders, id, 'id');
                emronStockholders = resetTableItemsId(emronStockholders);
                dispatch(setEditClient({...editClient, stockholders: emronStockholders}));
            }
        }
    }

    const handleEmronPaymentsChanges = {
        insert: (e, data) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));

            let tempEmronPayment = Object.assign({}, CLIENTS_DATA.newEmronPayment);
            if (data.field === "installation") {
                tempEmronPayment["installation"] = e.row.address;
                tempEmronPayment["installationType"] = e.row.type;
            } else {
                tempEmronPayment[data.field] = data.value;
            }
            if (tempEmronPayment && (tempEmronPayment.installationType || tempEmronPayment.amount || tempEmronPayment.month || tempEmronPayment.notes)) {
                let updatedEmronPayment = Object.assign({}, tempEmronPayment);
                let oldEmronPayments = editClient.emronPayments;
                updatedEmronPayment.no = oldEmronPayments.length + 1;
                updatedEmronPayment.id = oldEmronPayments.length + 1;
                updatedEmronPayment.clientName = editClient.name;
                dispatch(setEditClient({
                    ...editClient,
                    emronPayments: [...oldEmronPayments, updatedEmronPayment]
                }));
            }
        },
        update: (data, id, rowIndex) => {
            // Set if editing the form
            if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));

            let emronPayments = structuredClone(editClient.emronPayments);
            if (data?.installation) {
                emronPayments[rowIndex].installation = data.installation.row.address;
                emronPayments[rowIndex].installationType = data.installation.row.type;
            } else if (data?.productName) {
                emronPayments[rowIndex].productName = data.productName.row.name;
                emronPayments[rowIndex].productCode = data.productName.row.code;
            } else if (!isEmpty(data?.bankAccountsLimit)) {
                const bankDiff = (+data.bankAccountsLimit || 0) - (+emronPayments[rowIndex].bankAccountsLimit || 0);
                emronPayments[rowIndex].bankAccountsLimit = data.bankAccountsLimit;
                emronPayments[rowIndex].amount = +Number(+(emronPayments[rowIndex].amount || 0) + 1.5 * bankDiff).toFixed(2);
            } else {
                emronPayments[rowIndex] = {...emronPayments[rowIndex], ...data};
            }
            dispatch(setEditClient({...editClient, emronPayments: emronPayments}));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));
            if (editClient.emronPayments[rowIndex] && isEmpty(editClient.emronPayments[rowIndex].subscription_id)) {
                let cloneEmronPayments = structuredClone(editClient.emronPayments);
                cloneEmronPayments.splice(rowIndex, 1);
                dispatch(setEditClient({...editClient, emronPayments: cloneEmronPayments}));
            } else {
                toast.error("Η μηνιαία πληρωμή δεν γίνεται να διαγραφεί επειδή είναι συνδεδεμένη με συνδρομή.");
            }
        }
    }
    const headerButtonOnClick = () => {
        dispatch(setSelectedEmronPaymentsFilters({ clientName: editClient.name }));
        dispatch(openTabByType("emron-payments", TABS_DATA));
    }

    const [incrKey, setIncrKey] = useState(0);
    const [incrKey2, setIncrKey2] = useState(0);
    const [incrKey3, setIncrKey3] = useState(0);

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [editClient.emronPasswords])

    useEffect(() => {
        setIncrKey2(incrKey2 + 1);
    }, [editClient.stockholders])

    useEffect(() => {
        setIncrKey3(incrKey3 + 1);
    }, [editClient.emronPayments])

    useEffect(() => {
        fetchGEMHFinancials();
    }, [])

    const updateFromGEMH = () => {
        setUpdatingGEMH(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/client/update-from-gemh`, {
            company: company.id,
            client: editClient._id,
        }).then((res) => {
            if (res.data.status === "200") {
                if (res.data.totalFetched === 0) {
                    setShowFetchFromGEMH(false);
                    toast.info("Η άντληση ολοκληρώθηκε. Δεν βρέθηκε κανένα καινούργιο αρχείο / οικ. αποτέλεσμα κατά την άντληση.", {autoClose: 10000});
                } else {
                    setShowFetchFromGEMH(false);
                    toast.success("Επιτυχής άντληση.");
                    fetchGEMHFinancials();
                }
                dispatch(setEditClient(res.data.client));
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setUpdatingGEMH(false);
        })
    }

    const [financialTableData, setFinancialTableData] = useState([]);

    const fetchGEMHFinancials = () => {
        axios.post(`${process.env.REACT_APP_API_URL2}/client/fetch-gemh-financials`, {
            company: company.id,
            client: editClient._id,
        }).then((res) => {
            if (res.data.status === "200") {
                setFinancialTableData(res.data.data);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const handleDownloadGemhFile = async (cf) => {
        const fetchResp = await axios.post(`${process.env.REACT_APP_API_URL2}/cloud/action`, {
            action: "fetch",
            attemptConversion: false,
            currentPath: formatPath(cf.path),
            company: company.id,
            year: company.year,
        });
        if (fetchResp.data.status === "200") {
            const binaryString = atob(fetchResp.data.data);
            const name = getFileNameFromPath(cf.path);
            const byteArray = new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0)));
            let mimeType = getMimeType(name);
            const blob = new Blob([byteArray], { type: mimeType });
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        } else {
            toast.error("Σφάλμα κατά την άντληση εγγράφου.");
        }
    }

    const handleOpenGemhFile = async (cf) => {
        const fetchResp = await axios.post(`${process.env.REACT_APP_API_URL2}/cloud/action`, {
            action: "fetch",
            attemptConversion: true,
            currentPath: formatPath(cf.path),
            company: company.id,
            year: company.year,
        });
        if (fetchResp.data.status === "200") {
            const fromConversion = fetchResp.data.fromConversion;
            const binaryString = atob(fetchResp.data.data);
            const name = getFileNameFromPath(cf.path);
            const byteArray = new Uint8Array(binaryString.split('').map((char) => char.charCodeAt(0)));
            let mimeType = getMimeType(name);
            const blob = new Blob([byteArray], { type: mimeType });
            let blobUrl = URL.createObjectURL(blob);
            if (popExtension(name) === "pdf" || fromConversion) blobUrl += "#navpanes=0&view=Fit";
            window.open(blobUrl, "_blank");
            setTimeout(() => {
                URL.revokeObjectURL(blobUrl);
            }, 10_000)
        } else {
            toast.error("Σφάλμα κατά την άντληση εγγράφου.");
        }
    }

    const renderFinancialTables = () => {
        const periods = {};
        for (const d of financialTableData) {
            const period = d?.gemhPeriod || "Μη καθορισμένη";
            if (!periods[period]) {
                periods[period] = [d];
            } else {
                periods[period].push(d);
            }
        }
        const compArr = [];
        for (const period of Object.keys(periods)) {
            const data = periods[period];
            compArr.push(
                <React.Fragment>
                    <div style={{textAlign: "right"}}>
                        <strong>Περίοδος:</strong> {period}
                    </div>
                    <table className={"simpleClassicTable mb-3"}>
                        <colgroup>
                            <col span={1} style={{width: "25%"}}></col>
                            <col span={1} style={{width: "50%"}}></col>
                            <col span={1} style={{width: "25%"}}></col>
                        </colgroup>
                        <thead>
                        <tr>
                            <th>Ημερομηνία Υποβολής</th>
                            <th>Αρχείο</th>
                            <th>Ενέργειες</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.map((o, idx) => (
                            <tr key={`r-${period}-${idx}`}>
                                <td>{o.gemhDate}</td>
                                <td>{o.fileName}</td>
                                <td>
                                    <Badge bg={"primary"} style={{padding: "4px", cursor: "pointer"}} title={"Προβολή αρχείου"} onClick={() => handleOpenGemhFile(o)}><FaEye size={18} /></Badge>
                                    <Badge bg={"primary"} className={"ml-2"} style={{padding: "4px", cursor: "pointer"}} title={"Λήψη αρχείου"} onClick={() => handleDownloadGemhFile(o)}><FaDownload size={18} /></Badge>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </React.Fragment>
            )
        }
        return compArr;
    }

    return (
        <div className="new-client-emron">
            <div className="text-muted mb-1"><i>{t('ClientsGeneralEdit.table.title')} (Μόνο προβολή, τροποποίηση μόνο από την καρτέλα "Γενικά")</i></div>
            <EditableTable
                tableName="Edit Client Contact Points"
                key={"Edit Client Contact Points"}
                allowActions={false}
                allowToggleColumns={false}
                columns={clientContactPointsColumns}
                data={editClient.contactPoints}
                allowInsertRow={false}
                enableNewRowCheckbox={false}
                disabled={true}
            />
            <div className="text-muted mb-1"><i>{t('ClientsNewEmronEdit.password')}</i></div>
            <EditableTable
                tableName="Emron Passwords"
                key={"Emron Passwords" + incrKey}
                allowActions={true}
                allowToggleColumns={true}
                columns={passwordsColumns}
                data={editClient.emronPasswords}
                allowInsertRow={true}
                enableNewRowCheckbox={true}
                onUpdate={handlePasswordsChanges}
            />
            <div className="text-muted mb-1"><i>{t('ClientsNewEmronEdit.stockholders')}</i></div>
            <Col sm='12' md="3">
                <div className="mb-3">
                    <label className="" htmlFor="capital">{t('ClientsNewEmronEdit.capital')}</label>
                    <AccountingBox
                        name="capital"
                        className="mb-3 form-control"
                        placeholder={t('ProductsNewGeneralEdit.preferredPrice.placeholder')}
                        defaultValue={editClient?.capital}
                        key={editClient?.capital}
                        onBlur={(e) => handleOnChange(e)}
                    />
                </div>
            </Col>
            <EditableTable
                tableName="Emron Stockholders"
                key={"Emron Stockholders" + incrKey2}
                allowActions={true}
                allowToggleColumns={true}
                columns={stackholdersColumns}
                data={editClient.stockholders}
                allowInsertRow={true}
                enableNewRowCheckbox={true}
                onUpdate={handleStockholdersChanges}
            />
            {company.vatNumber === "800434990" && (
                <React.Fragment>
                    <div className="text-muted mb-1">
                        <i>Μηνιαίες Χρεώσεις</i>
                        <Button size={"sm"} variant="primary" style={{float: "right", marginBottom: "10px"}} onClick={() => headerButtonOnClick()}>Μετάβαση στην Αναφορά Μηνιαίων Χρεώσεων</Button>
                    </div>
                    <EditableTable
                        tableName="Emron Payments"
                        key={"Emron Payments" + incrKey3}
                        allowActions={true}
                        allowToggleColumns={true}
                        columns={emronPaymentsColumns}
                        data={editClient.emronPayments}
                        allowInsertRow={true}
                        enableNewRowCheckbox={true}
                        onUpdate={handleEmronPaymentsChanges}
                    />
                    <div className="text-muted mb-1"><i>Δεδομένα ΓΕΜΗ</i></div>
                    <Button size={"sm"} className={"mb-2"} onClick={() => setShowFetchFromGEMH(true)}>Άντληση Οικ. Καταστάσεων από το ΓΕΜΗ</Button>
                    {editClient.gemhUrl && (
                        <Button size={"sm"} className={"ml-2 mb-2"} onClick={() => window.open(editClient.gemhUrl, "_blank")}>Άνοιγμα καταχωρημένης ιστοσελίδας</Button>
                    )}
                    {financialTableData.length > 0 && (
                        <Accordion className={"mb-3"}>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Οικονομικές Καταστάσεις ΓΕΜΗ</Accordion.Header>
                                <Accordion.Body>
                                    {renderFinancialTables()}
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    )}
                    <Modal show={showFetchFromGEMH} onHide={() => setShowFetchFromGEMH(false)} backdrop={"static"}>
                        <Modal.Header closeButton>
                            <Modal.Title>Άντληση Οικονομικών Καταστάσεων από το ΓΕΜΗ</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Είσαστε σίγουροι ότι θέλετε να πραγματοποιήσετε άντληση οικονομικών καταστάσεων από το ΓΕΜΗ;
                            Η διαδικασία θα διαρκέσει λίγο χρόνο.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-primary" onClick={() => setShowFetchFromGEMH(false)} disabled={updatingGEMH}>
                                Όχι, κλείσιμο
                            </Button>
                            <Button variant="primary" onClick={() => updateFromGEMH()} disabled={updatingGEMH}>
                                Ναι, άντληση {updatingGEMH && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </React.Fragment>
            )}
        </div>
    )
}

export default EditClientEmron;
